import { useQuery } from "@tanstack/react-query";
import { __PermisosNotPage } from "request/configuration/__Permissions";

// Hook para obtener permisos sin paginación
export const usePermisosNotPage = (token, enabled = true) => {
  return useQuery({
    queryKey: ["permisosNotPage"],
    queryFn: async () => {
      const res = await __PermisosNotPage(token);
      
      if (res.data.status?.code === 403) {
        throw new Error(res?.data?.status?.message);
      }
      
      // Retornar los datos tal como vienen del backend
      return res?.data?.status?.data || [];
    },
    enabled: enabled && !!token,
    staleTime: 5 * 60 * 1000, // 5 minutos (permisos pueden cambiar más frecuentemente)
    gcTime: 5 * 60 * 1000, // 5 minutos
    refetchOnWindowFocus: false,
    retry: 2,
    retryDelay: 1000
  });
};
